import headers from './detailHeaders'
//
export default [
    {
        name: 'g_originator_user_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Responsable',
        },
    },
    {
        name: 'wh_warehouse_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Bodega solicitante',
        },
    },
    {
        name: 'pch_provider_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Proveedor',
        },
    },
    {
        name: 'pch_provider_branch_offices_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Sucursal del proveedor',
        },
    },
    {
        name: 'pch_payment_condition_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Método pago',
        },
    },
    {
        name: 'observation',
        type: 'text-field',
        flex: {
            sm6: true,
            lg12: true,
        },
        props: {
            label: 'Observación',
        },
    },
    {
        name: 'pch_detail_purchase_orders',
        type: 'table-field',
        flex: {
            xs12: true,
            'd-grid': true,
        },
        props: {
            toolbarTitle: 'Detalle de productos de orden de compra',
            headers,
        },
    },
]
